import { sectionHeading } from '@mage-ui/styled-system/recipes';
import { SectionHeadingTitle } from './SectionHeadingTitle';
import { SectionHeadingTop } from './SectionHeadingTop';

export const SectionHeading = ({ data, ...props }) => {
  const classes = sectionHeading();
  return (
    (data?.meta || data?.epi || data?.title || data?.intro) && (
      <div className={classes.root} {...props}>
        {data?.meta || data?.epi ? <SectionHeadingTop data={data} /> : null}
        {data?.title || data?.intro ? (
          <SectionHeadingTitle data={data} />
        ) : null}
      </div>
    )
  );
};
